module.exports = __webpack_public_path__ + "static/img/brand-03.0fab616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-03.png
// module id = XQbh
// module chunks = 0